export const SET_CERTIFICATION_CLONE_MODAL_VALUE = 'SET_CERTIFICATION_CLONE_MODAL_VALUE';
export const SET_ADD_NOTE_MODAL_VALUE = 'SET_ADD_NOTE_MODAL_VALUE';
export const RESTORE_ADD_NOTE_MODAL_VALUE = 'RESTORE_ADD_NOTE_MODAL_VALUE';
export const TOGGLE_UPDATE_NOTES = 'TOGGLE_UPDATE_NOTES';
export const RESTORE_REVOKE_NOTE_MODAL_VALUE = 'RESTORE_REVOKE_NOTE_MODAL_VALUE';
export const SET_REVOKE_MODAL_VALUE = 'SET_REVOKE_MODAL_VALUE';
export const CHECK_REVOKE_STATUS = 'CHECK_REVOKE_STATUS';
